import React, { useEffect, useState } from 'react';
import { MessageModal } from 'components/newIdentifyMethods/videoModals/MessageModal';
import { i18n } from 'core/i18n';
import { ProgressBar } from 'componentsV2/ProgressBar/ProgressBar';

const { formatText } = i18n;
export const WrongFaceMatchModalContent = ({ onFinish, statusNumber, statusCode, type }) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const growthInterval = setInterval(() => {
            setProgress(oldProgress => {
                if (oldProgress === 100) {
                    onFinish();

                    return oldProgress;
                }

                return oldProgress + 25;
            });
        }, 2000);

        return () => clearInterval(growthInterval);
    }, []);

    return (
        <>
            <MessageModal
                title={formatText('identity-videoCallErrorTitle')}
                message={formatText('identity-videoCallWrongFaceMatch')}
                statusNumber={statusNumber}
                statusCode={statusCode}
                videoType={type}
                showFooter={false}
            >
                <ProgressBar progress={progress} />
            </MessageModal>
        </>
    );
};
